import { useContext, useState } from "react";
import { useLoginContext } from "../../../App";
import { fetchMyOrganizationsData } from "../../../services/b2b-users-apiService";
import { B2BContentContext } from "../../layout/Layout";
import { showNotification } from "../../b2b-common/Notification";
import { useQuery } from "@tanstack/react-query";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";

const useMyOrganizations = () => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContext(B2BContentContext);
    const { t } = useB2BTranslation('b2b-users');
    const [isFetchingMyOrganizations, setIsFetchingMyOrganizations] = useState(false);

    const fetchMyOrganizations = async () => {
        try {
            setIsFetchingMyOrganizations(true);
            const response = await fetchMyOrganizationsData(loginData.accessToken);
            return response;
        } catch (error) {
            console.error('Error fetching my organizations: ' + error.message);
            showNotification(setNotification, t('Error fetching my organizations'), 'error', 5000);
        } finally {
            setIsFetchingMyOrganizations(false);
        }
    }

    const { data: myOrganizations } = useQuery({
        queryKey: ['myOrganizationsData', loginData.userUuid],
        queryFn: () => fetchMyOrganizations(),
        enabled: !!loginData?.userUuid,
    });

    return { myOrganizations, isFetchingMyOrganizations };
}

export default useMyOrganizations;